import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import {
  ArrowLeft,
  ArrowRight,
  Quote,
} from "lucide-react";

const testimonials = [
  {
    id: 1,
    name: "Rajesh Kumar",
    company: "bharath.co",
    image: "https://i.pravatar.cc/100?img=12",
    review:
      "The team delivered an amazing website that exceeded our expectations. Great communication, on-time delivery, and excellent support throughout the project.",
  },
  {
    id: 2,
    name: "Ayesha Khan",
    company: "TechNova",
    image: "https://i.pravatar.cc/100?img=32",
    review:
      "MSM Technologies transformed our business with a modern website and mobile application. Highly professional team and excellent quality.",
  },
  {
    id: 3,
    name: "John Peter",
    company: "Innovate Labs",
    image: "https://i.pravatar.cc/100?img=15",
    review:
      "Their development team was responsive, creative, and delivered everything on time. We are extremely satisfied with the final product.",
  },
];

export default function TestimonialSection() {
  const [current, setCurrent] = useState(0);

  // Auto Slide
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent((prev) => (prev + 1) % testimonials.length);
    }, 4000);

    return () => clearInterval(timer);
  }, []);

  const nextSlide = () =>
    setCurrent((prev) => (prev + 1) % testimonials.length);

  const prevSlide = () =>
    setCurrent(
      (prev) => (prev - 1 + testimonials.length) % testimonials.length
    );

  return (
    <section className="py-24 bg-gradient-to-r from-white via-blue-50 to-white">
      <div className="max-w-7xl mx-auto px-6">

        {/* Heading */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <p className="text-[#2563eb] font-semibold text-xl">
            Testimonials
          </p>

          <h2 className="text-5xl font-bold mt-4">
            What Our Clients Say
          </h2>

          <p className="mt-5 text-gray-600 text-xl">
            We value our clients and their feedback.
          </p>
        </motion.div>

        {/* Slider */}
        <div className="relative flex items-center">

          {/* Left Button */}
          <button
            onClick={prevSlide}
            className="hidden md:flex absolute left-0 z-20 w-14 h-14 bg-white rounded-full shadow-lg items-center justify-center hover:bg-blue-600 hover:text-white transition"
          >
            <ArrowLeft />
          </button>

          {/* Card */}
          <div className="w-full md:px-24">

            <AnimatePresence mode="wait">

              <motion.div
                key={current}
                initial={{ opacity: 0, x: 80 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: -80 }}
                transition={{ duration: .5 }}
                className="bg-white rounded-[35px] shadow-xl border p-12 text-center"
              >
                <Quote
                  size={55}
                  className="text-[#2563eb] mx-auto mb-6"
                />

                <p className="text-2xl text-gray-600 leading-10 max-w-4xl mx-auto">
                  {testimonials[current].review}
                </p>

                <div className="mt-10 flex justify-center items-center gap-5">

                  <img
                    src={testimonials[current].image}
                    alt=""
                    className="w-16 h-16 rounded-full object-cover"
                  />

                  <div className="text-left">
                    <h3 className="text-2xl font-semibold">
                      {testimonials[current].name}
                    </h3>

                    <p className="text-gray-500">
                      {testimonials[current].company}
                    </p>
                  </div>

                </div>

              </motion.div>

            </AnimatePresence>

          </div>

          {/* Right Button */}
          <button
            onClick={nextSlide}
            className="hidden md:flex absolute right-0 z-20 w-14 h-14 bg-white rounded-full shadow-lg items-center justify-center hover:bg-blue-600 hover:text-white transition"
          >
            <ArrowRight />
          </button>

        </div>

        {/* Dots */}
        <div className="flex justify-center gap-4 mt-10">

          {testimonials.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrent(index)}
              className={`w-4 h-4 rounded-full transition ${
                current === index
                  ? "bg-blue-600 scale-125"
                  : "border border-black"
              }`}
            />
          ))}

        </div>

      </div>
    </section>
  );
}